import { Link } from 'react-router-dom';
import { FaWix, FaSquarespace, FaCodepen } from 'react-icons/fa';
import { IoLogoVercel } from 'react-icons/io5';
import { SiSanity } from 'react-icons/si'
import { MdOpenInNew } from "react-icons/md";
import usePageTitle from '../hooks/usePageTitle';

import("../styles/home.scss");

function Home() {
  usePageTitle('Home | Dochano');

  return (
    <section id="Home">

      <div id="denverBackdrop">
        <p>Embracing Continued Professional Development</p>
      </div>

      <h2>Deeper Dive</h2>
      <div className="flex">
        <div>
          <img src={require('../assets/AI.png')} alt="AI Robot at computer discussing with live human." />
          <h3>Artificial Intelligence</h3>
          <p>I am taking the time to dive deeper into AI by going beyond prompts within services and creating the basics from scratch. Using Python, I have created a machine learning process that will learn from prior answers to guess an animal. I have also implemented a system that will identify words within PDF files to a CSV so I can identify which files have a given word or phrase rather than opening each up individually.</p>
          <Link to="exploration#python">Check out the Python section on Exploration page</Link>
          <p><Link to="learning">Continued Learning can be found on Learning page</Link></p>
        </div>

        <div>
          <img src={require('../assets/code.png')} alt="Screenshot of VSCode" />
          <h3>Website Builders</h3>
          <p>I am researching the evolving website builder space. Coming from a developer who spent his time creating websites from scratch and learning all the tools has made me interested in learning more about where the industry lacks and even where it excels.</p>
          <ul>
            <li><FaSquarespace /> Squarespace - cost to go live, intro version lacks features. Assisted City Consul Members campaign website using Squarespace. They won.</li>
            <li><FaWix /> WIX - free with ads, robust features to start with<br /><a href="https://grjohnson6.wixsite.com/donchano" target="_blank" rel="noopener noreferrer">grjohnson6 <MdOpenInNew title="Open in new window" /></a></li>
            <li><IoLogoVercel /> Vercel - sophisticated developer start with flexibilty and multiple options.</li>
            <li><SiSanity /> Sanity.io - built <Link to="RetroTime">Retrospective</Link> headless CMS content to share</li>
          </ul>
        </div>
        
        <div>
          <img src={require('../assets/group-discussion.png')} alt="silhouettes of men and women headshot connected together like a network" />
          <h3>Management</h3>
          <p>The skills I developed in my management career is growing the team through communication and collaboration to help each other reach new goals. I have enhanced CodePen potential new hire quiz to identify a developers skills. Been successful in growing team members careers into leadership roles or taking on a new opportunity within the company to help them pursue their interests. I have even taking the time to create meaningful Retrospectives for the team to get to know one another and learn from past experiences.</p>
          <Link to="RetroTime">Learn more on my Retrospective Journey</Link>
          <p><FaCodepen /> CodePen - Check out my personal playground at <a href="https://codepen.io/grjohnson" target="_blank" rel="noopener noreferrer">grjohnson <MdOpenInNew title="Open in new window" /></a></p>
        </div>
      </div>

      <div id="Local">
        <img src={require('../assets/denver-buildings.jpg')} alt="Buildings off of Curtis Street in Downtown Denver" />
        <div>
          <h2>Colorado Based</h2>
          <p>I love the Denver Metro Area and am looking for a new role as a Software Engineering Manager. I have over 24 years FinTech experience working for a Communify Fincentric. Which I have seen evolve from <a href="https://www.crunchbase.com/organization/wall-street-on-demand" target="_blank" rel="noopener noreferrer">Wall Street On Demand to Markit <MdOpenInNew title="Open in new window" /></a> (6/2010), then to <a href="https://www.crunchbase.com/organization/ihs-markit" target="_blank" rel="noopener noreferrer">IHS Markit <MdOpenInNew title="Open in new window" /></a> (7/2016), to <a href="https://www.crunchbase.com/organization/s-p-global" target="_blank" rel="noopener noreferrer">S&P Global <MdOpenInNew title="Open in new window" /></a> (2/2022), to finally reside at <a href="https://communify.com/" target="_blank" rel="noopener noreferrer">Communify Fincentric <MdOpenInNew title="Open in new window" /></a> (10/2024). Building research sites for the largest financial companies around the world.</p>
        </div>
      </div>

    </section>
  );
}

export default Home;